import React from 'react';
import Link from 'next/link';

export const Footer = () => {
  return (
    <footer className="bg-[#26554A] text-primary-foreground py-12 px-6">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <Link href="/" className="font-display text-2xl tracking-tight block mb-4">
            WILLDONE
          </Link>
          <p className="text-primary-foreground/80 max-w-xs mb-6">
            Democratising legal access through technology and design.
          </p>
          <a href="mailto:hello@willdone.co.uk" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
            hello@willdone.co.uk
          </a>
        </div>
        <div>
          <h4 className="font-bold uppercase tracking-widest text-xs mb-6 text-primary-foreground">Platform</h4>
          <ul className="space-y-3 text-sm text-primary-foreground/60">
            <li><Link href="/write-a-will-online" className="hover:text-primary-foreground">Create Will</Link></li>
            <li><Link href="/ultimate-will-guide" className="hover:text-primary-foreground">Resources</Link></li>
            <li><Link href="/about-us" className="hover:text-primary-foreground">About Us</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold uppercase tracking-widest text-xs mb-6 text-primary-foreground">Legal</h4>
          <ul className="space-y-3 text-sm text-primary-foreground/60">
            <li><Link href="/terms-of-service" className="hover:text-primary-foreground">Terms of Service</Link></li>
            <li><Link href="/privacy-policy" className="hover:text-primary-foreground">Privacy Policy</Link></li>
            <li><Link href="/cookie-policy" className="hover:text-primary-foreground">Cookie Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="container mx-auto mt-12 pt-8 border-t border-primary-foreground/20 text-sm text-primary-foreground/80 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="text-center md:text-left space-y-3">
          <p>© {new Date().getFullYear()} Willdone Platform. All rights reserved.</p>
          <p className="max-w-2xl opacity-80 leading-relaxed">
            Willdone is an independent digital service providing legal forms and information, not a law firm. We do not provide legal advice. Our services are not a substitute for the advice of a qualified solicitor, especially for complex estates or specific legal issues.
          </p>
        </div>
      </div>
    </footer>
  );
};
